import React from "react";
import { Menu } from "lucide-react";

const DashboardHeader = ({ isSidebarOpen, setIsSidebarOpen, currentView }) => {
  return (
    <header className="bg-orange-500 shadow-sm sticky top-0 z-10">
      <div className="px-4 py-3 flex items-center justify-between">
        <button
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className="text-white hover:bg-orange-600 p-2 rounded"
        >
          <Menu className="h-6 w-6" />
        </button>
        <h1 className="text-lg font-semibold text-white">
          {currentView.charAt(0).toUpperCase() + currentView.slice(1)}
        </h1>
      </div>
    </header>
  );
};

export default DashboardHeader;
